module.exports = {
  apiHost: "https://api.alirfanrawdh.sensoreal.app",
  assetsHost: "https://assets.alirfanrawdh.sensoreal.app",

  header: {
    text: "Your Favourite Selections",
    logo: false,
    color: "#fff",
  },
  langs: [
    { code: "en", dir: "ltr" },
    { code: "ar", dir: "rtl" },
  ],
  style: {
    primaryColor: "#000",
  },
  contact: {
    website: "",
    address: "",
    phone: "",
    email: "",
  },
  links: {
    privacy: "",
    youtube: "",
    linkedin: "",
    twitter: "",
    instagram: "",
    facebook: "",
  },
};
